import { actionTypes } from 'actions/Users/types'

export const defaultState = {
  isLoading: false,
  users: [],
  showModal: false,
  emails: '',
}

export const userReducer = (state = defaultState, action) => {
  const { type, payload } = action
  switch (type) {
    case actionTypes.TOGGLE_MODAL:
      return {
        ...state,
        showModal: !state.showModal,
        emails: '',
      }
    case actionTypes.HANDLE_EMAIL_CHANGE:
    case `${actionTypes.DELETE_USER}_REQUEST`:
    case `${actionTypes.DELETE_USER}_SUCCESS`:
      return {
        ...state,
        users: [],
      }
    case `${actionTypes.DELETE_USER}_FAIL`:
    case `${actionTypes.SEND_REPORT}_REQUEST`:
    case `${actionTypes.SEND_REPORT}_SUCCESS`:
    case `${actionTypes.SEND_REPORT}_FAIL`:
    case `${actionTypes.FETCH_USERS}_REQUEST`:
    case `${actionTypes.FETCH_USERS}_SUCCESS`:
    case `${actionTypes.FETCH_USERS}_FAIL`:
      return {
        ...state,
        ...payload,
      }
    default:
      return state
  }
}
